import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { getAccountId } from 'redux/actions/accountActions'
import { logWithTime } from 'util/screenUtils'
import { handleErrors, handleErrorsWithCode } from './AssetController'
import { JSON_CONTENT_TYPE, getCoreServiceFetchOptions } from './CoreServiceController'

/**
 * 
 * @param {*} withApiKey If true include x-api-key
 * @returns 
 */
export const getSocialServiceHeaders = (withApiKey) => {
    let headers = {
        'Content-Type': 'application/json',
        'x-user-id': getAccountId(true)
    }
    if (withApiKey) {
        headers = { ...headers, 'x-api-key': process.env.REACT_APP_API_KEY }
    }
    return headers
}

/**
 * You cannot set contenType on a POST with formData becuase for some reason
 * that blows the server with Entity too large.
 * @param {*} method 
 * @param {*} formData 
 * @returns 
 */
export const getSocialServiceFetchOptions = (method, body, formUrlEncoded) => {
    const contentType = JSON_CONTENT_TYPE
    switch (method) {
        default:
        case 'GET':
            return {
                method,
                headers: {
                    'Content-Type': contentType,
                    'x-user-id': getAccountId()
                }
            }

        case 'POST':
            if (formUrlEncoded) {
                return {
                    method,
                    headers: {
                        'x-user-id': getAccountId()
                    },
                    body
                }
            } else {
                return {
                    method,
                    headers: {
                        'Content-Type': contentType,
                        'x-user-id': getAccountId()
                    },
                    body
                }
            }
    }

}
export const addEmbed = async (messageId, embed) => {
    const embedParams = { messageId, embed }
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/addEmbed`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify(embedParams),
    })
        .then(handleErrors)
        .then(() => {
            console.log('...added embed')
            return true
        })
}

/**
 * @todo Unused
 * Add a Message directly to Social Service
 * @param {*} message 
 * @returns 
 */
export const addMediaMessage = async (message) => {
    logWithTime('addMediaMessage', message)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/addMessage`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify(message),
    })
        .then(handleErrors)
        .then(() => {
            return true
        })
}

/**
 * 
 * @param {*} name 
 * @param {*} description 
 * @param {*} messageId         Id of initial Message added to Collection
 * @param {*} roomId            Id of Room to which this Collection belongs
 * @param {*} media             Initial Message media for Collection
 * @param {*} accessType        Defaults to PROTECTED
 * @returns 
 */
export const addCollection = async (name, description, messageId, roomId, media, accessType = ACCESS_TYPES.PROTECTED) => {
    const collection = { name, description, messageId, roomId, media, accessType }
    logWithTime('addCollection', collection)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/add`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify(collection),
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

/**
 * 
 * @param {*} collectionId 
 * @param {*} messageId 
 * @returns 
 */
export const addToCollection = async (collectionId, messageId) => {
    logWithTime(`addToCollection ${collectionId}/${messageId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/addMessage/${collectionId}/${messageId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

/**
 * @todo Unused
 * Because public anonymous access is allowed, user is not required. Instead the
 * Api key is required. Note that this uses the Social Service because engagements
 * are attached to Messages.
 * @param {*} action    An ENGAGEMENT_TYPES value
 * @param {*} messageId Id of Message
 * @param {*} user      Id of User
 * @param {*} duration  Length of time in seconds at engagement
 * @returns 
 */
export const addEngagement = async (action, messageId, user, duration) => {
    const engagement = { action, messageId, user, duration }
    logWithTime('addEngagement', engagement)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}harmonize/addEngagement`
    return fetch(url, {
        method: 'POST',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(engagement),
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

/**
 * Add a Like from the signed-in User to the specified Message
 * @param {*} messageId 
 * @returns Updated Message
 */
export const addLikeToMessage = async (messageId) => {
    logWithTime('addLike', messageId)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}harmonize/addLike/${messageId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((updatedMessage) => {
            return updatedMessage
        })
}

/**
 * Add or update a Reaction to the specified Message for the signed-in User
 * @param {*} reaction {messageId, unifiedEmoji, playTime}
 * @returns 
 */
export const addReaction = async (reaction) => {
    logWithTime('addReaction', reaction)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}harmonize/addReaction`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify(reaction),
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((reaction) => {
            return reaction
        })
}


/**
 * 
 * @param {*} collectionId 
 * @returns 
 */
export const deleteCollectionById = async (collectionId) => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/delete/${collectionId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

/**
 * Delete all highlight reactions from the Message
 * @param {*} messageId 
 * @returns 
 */
export const deleteHighlightReactions = async (messageId) => {
    logWithTime(`deleteHighlightReaction message ${messageId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}harmonize/deleteHighlightReactions/${messageId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

/**
 * 
 * @param {*} artistName 
 * @param {*} songName 
 * @param {*} userId
 * @returns 
 */
export const getArtistSong = async (artistName, songName, userId = '0') => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/artist/${artistName}/${songName}/${userId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((song) => {
            return song
        })
}


/**
 * Get the Collection and all its Messages. userId determines visibility of DRAFT Messages as well
 * as liked flag.
 * @param {*} collectionId 
 * @param {*} userId 
 * @returns 
 */
export const getEntireCollection = async (collectionId, userId = 0) => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/getentire/${collectionId}/${userId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((collection) => {
            return collection
        })
}

/**
 * Complex service request with a query that may have these parameters:
 * { requestedMessageId,
        requestedSong, username, collectionId, collectionType, publicAccess}

   The call also includes x-user-id in the request headers.
 * @param {*} query 
 * @returns 
 */
export const listRequestedMessages = async (query, start, count) => {
    logWithTime('listRequestedMessages', query)
    const data = { ...query, start, count }
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/list/requested`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(true),
        body: JSON.stringify(data)
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((requestedMessages) => {
            console.log(`got ${requestedMessages.length} messages`, requestedMessages)
            return requestedMessages
        })
}

/**
 * This will send x-user-id if account is signed in so that the appropriate
 * Likes can be added to the returned messages.
 * @param {*} categoryMode One of CATEGORY_MODES used to filter query on Social Service
 * @param {*} start 
 * @param {*} count 
 * @returns 
 */
export const listSongsAndVideo = async (categoryMode, start, count) => {
    const { type } = categoryMode
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/list/${start}/${count}/${type}`
    return fetch(url, {
        method: 'GET',
        headers: {
            ...getSocialServiceHeaders(), ...{
                'x-api-key': process.env.REACT_APP_API_KEY
            }
        }
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((songs) => {
            console.log(`got ${songs.length} songs`)
            return songs
        })
}
/**
 * Get a Collection with its first Message
 * @param {*} collectionId 
 * @param {*} userId        Defaults to 0. If not 0, then all Collection Messages that can be viewed by the User are returned as well
 * @returns 
 */
export const getCollectionById = async (collectionId, userId = 0) => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/get/${collectionId}/${userId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((collection) => {
            return collection
        })
}

/**
 * Get the single Reaction document for the specified Message
 * @param {*} messageId 
 * @returns 
 */
export const getReaction = async (messageId) => {
    console.log(`getReaction ${messageId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}reaction/list/${messageId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((reaction) => {
            return reaction
        })

}
export const getChatLog = async (roomId, start = 0, limit = 50) => {
    console.log(`getChatLog ${roomId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}chat/list/${roomId}/${start}/${limit}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((chatLog) => {
            return chatLog
        })

}

/**
 * Get the Collections for this Room (not the User)
 * @param {*} roomId 
 * @returns 
 */
export const getCollections = async (roomId) => {
    console.log(`getCollections ${roomId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/list/${roomId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,
        },
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((collections) => {
            return collections
        })

}

/**
 * Get the Collections for the signed-in user User
 * @returns 
 */
export const getCollectionsForUser = async () => {
    console.log(`getCollectionsForUser`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/listuser`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((collections) => {
            return collections
        })

}
/**
 * @todo Unused
 * @param {*} messageId 
 * @returns 
 */
export const getLikes = async (messageId) => {
    console.log(`getLikes ${messageId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/likes/${messageId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders(),
    })
        .then(handleErrors)
        .then((res) => res.json())
        .then((likes) => {
            return likes
        })
}

/**
 * This is an UNAUTHENTICATED call protected by the REACT_APP_API_KEY that must match the 
 * one configured on the Social Service. The userId is provided so that Likes
 * can be returned with the message
 * @param {*} messageId 
 * @param {*} userId    Requesting userId. Default is '0'
 * @returns 
 */
export const getMessage = async (messageId, userId = '0') => {
    //console.log(`getMessage ${messageId}`)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/get/${messageId}/${userId}`
    return fetch(url, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
        }
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((message) => {
            return message
        })
}

/**
 * 
 * @param {*} roomId 
 * @param {*} start 
 * @param {*} count 
 * @param {*} category 
 * @returns 
 */
export const getMessages = async (roomId, start, count, categories) => {
    const data = { roomId, start, count, categories }
    console.log(`getMessages ${start} for ${count}`, data)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}messages/get`
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY
        },
        body: JSON.stringify(data)
    })
        .then(handleErrors)
        .then((res) => res.json())
        .then((messages) => {
            return messages
        })
}


export const getNotifications = async (start, count) => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}notification/list/${start}/${count}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((res) => res.json())
        .then((notifications) => {
            return notifications
        })
}

/**
 * Check if the signed-in User has at least one Message.
 * @returns 
 */
export const hasMessages = async () => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/hasMessages`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then((response) => {
            console.log(`hasMessages response`, response)
            return response.status === 200
        })
}

export const markNotificationRead = async (notificationId) => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}notification/read/${notificationId}`
    return fetch(url, {
        method: 'GET',
        headers: getSocialServiceHeaders()
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}
/**
 * @todo Unused
 * @param {*} query
 * @param {*} createdAt 
 * @returns 
 */
export const summarize = async (query, createdAt) => {
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}ai/summarizeSubscribedRooms`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify({ query, createdAt }),
    })
        .then(handleErrors)
        .then((res) => res.json())
        .then((summary) => {
            logWithTime('Received summary', summary)
            return summary
        })
}

export const updateCollection = async (collection) => {
    logWithTime('updateCollection', collection)
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}collection/update`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify(collection),
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

export const updateSequences = async (sequences) => {
    logWithTime('updateSequences')
    const url = `${process.env.REACT_APP_SOCIAL_SERVICE}message/updateSequences`
    return fetch(url, {
        method: 'POST',
        headers: getSocialServiceHeaders(),
        body: JSON.stringify(sequences),
    })
        .then(handleErrorsWithCode)
        .then(() => {
            return true
        })
}

/**
 * Upload a JPEG, MP3, MP4 or PDF. No other type is currently allowed.
 * Note that this uses the Core Service for uploading audio and video and the Social Service for uploading
 * everything else. Why?
 *
 * @param {*} fileData
 * @param {*} params        {roomId,username,messageId} messageId is used so Core Service can update Message media after long HLS build
 * @param {*} isImage       If true the Social Service is used 
 * @returns
 */
export const uploadMedia = async (fileData, params, isImage) => {
    console.log(`uploadMedia isImage ${isImage} params`, params)
    const formData = new FormData()
    formData.append('media', fileData)
    formData.append('params', JSON.stringify(params))
    const fetchOptions = isImage ? getSocialServiceFetchOptions('POST', formData, true)
        : getCoreServiceFetchOptions('POST', formData, true)
    const host = isImage ? process.env.REACT_APP_SOCIAL_SERVICE : process.env.REACT_APP_CORE_SERVICE
    const url = `${host}upload/media`
    return fetch(url, fetchOptions)
        .then(handleErrors)
        .then((res) => res.json())
        .then((media) => {
            console.log('Received upload result', media)
            return media
        })
}